import SkeletonViewContentLoader from 'react-content-loader';

export default SkeletonViewContentLoader;
